import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { FiltroAtividade } from "../../core/filtro/filtro-atividade";
import { PlanejamentoOficina } from '../../core/planejamento-oficina';
import { DataUtilService } from "../../services/commons/data-util.service";
import { PlanejamentoOficinaService } from '../../services/planejamento-oficina/planejamento-oficina.service';
import { ToastService } from '../../services/toast/toast.service';
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'planejamento-oficina',
  templateUrl: './planejamento-oficina.component.html',
  styleUrls: ['./planejamento-oficina.component.css']
})
export class PlanejamentoOficinaComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  filtro: FiltroAtividade = new FiltroAtividade();
  planejamentoOficina: PlanejamentoOficina = new PlanejamentoOficina();

  mostrarTabela = false;
  msg: string;

  displayedColumns: string[] = ['descricao', 'datainicio', 'datafim', 'maxparticipantes', 'acoes'];
  dataSource: MatTableDataSource<PlanejamentoOficina> = new MatTableDataSource();

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  menu: string;
  area: string;
  constructor(
    private planejamentoOficinaService: PlanejamentoOficinaService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private dataUtilService: DataUtilService,
    private toastService: ToastService
  ) { }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);
    this.dataSource.paginator = this.paginator;
    this.area = this.getArea();
    this.filtro.area = this.area;
    this.consultar();
  }

  getMenu(): string {
    const primeiroSegmento = this.router.url.split('/')[1];
    return primeiroSegmento.startsWith('menu') ? primeiroSegmento : undefined;
  }

  private getArea(): string {
    this.menu = this.getMenu();
    return this.menu && this.menu == "menu-sap" ? 'S' : (this.menu && this.menu == "menu-pedagogico" ? 'P' : null);
  }

  limpar() {
    this.mostrarTabela = false;
    this.dataSource.data = [];
    this.msg = '';

    this.filtro = new FiltroAtividade();
  }

  consultar() {
    if (this.filtro.descricao ||
        this.filtro.projeto ||
        this.filtro.dataInicio ||
        this.filtro.dataFim) {
      this.planejamentoOficinaService.getByFilter(this.filtro).subscribe((oficinas: PlanejamentoOficina[]) => {
        if (!oficinas || oficinas.length === 0) {
          this.mostrarTabela = false;
          this.msg = 'Nenhum registro para a pesquisa selecionada';
        } else {
          oficinas = oficinas
          .sort((a, b) => new Date(b.dataInicio).getTime() - new Date(a.dataInicio).getTime());


          this.dataSource.data = oficinas ? oficinas : [];
          this.mostrarTabela = true;
          this.verificaMostrarTabela(oficinas);
        }
      });
    } else {
      this.planejamentoOficinaService.getAllByArea(this.filtro.area).subscribe((oficinas: PlanejamentoOficina[]) => {
        oficinas = oficinas
        .sort((a, b) => new Date(b.dataInicio).getTime() - new Date(a.dataInicio).getTime());
        this.dataSource.data = oficinas ? oficinas : [];
        this.mostrarTabela = true;
        this.verificaMostrarTabela(oficinas);
      });
    }
  }


  verificaMostrarTabela(oficinas: PlanejamentoOficina[]) {
    if (!oficinas || oficinas.length === 0) {
      this.mostrarTabela = false;
      this.msg = 'Nenhuma oficina cadastrada.';
    } else {
      this.mostrarTabela = true;
    }
  }


  atualizar(oficina: PlanejamentoOficina) {
    oficina.area = this.area;
    const rota = this.menu ? this.menu+'/oficinaturmas/cadastrar':'oficinaturmas/cadastrar';
    this.router.navigate([rota], { queryParams: { id: oficina.id } });
  }

  aprovar(oficina: PlanejamentoOficina) {
    this.planejamentoOficinaService.aprovar(oficina.id).subscribe(() => {
      this.toastService.showSucesso('Planejamento de oficina aprovado com sucesso.');
    });
  }

  deletar(oficina: PlanejamentoOficina) {
    this.chamaCaixaDialogo(oficina);
  }

  chamaCaixaDialogo(oficina: PlanejamentoOficina) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      pergunta: `Certeza que deseja excluir a oficina ?`,
      textoConfirma: 'SIM',
      textoCancela: 'NÃO'
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirma => {
      if (confirma) {
        this.planejamentoOficinaService.excluir(oficina.id).subscribe(() => {
          this.consultar();
        });
      } else {
        dialogRef.close();
      }
    }
    );
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  onValorChangeProjeto(event: any) {
    this.filtro.projeto = event;
  }

}
